import React from 'react';
import { FaFileExport } from 'react-icons/fa6';
import { SpinningLoadingIcon } from '~/libs/ui/atoms/SpinningLoadingIcon';

export interface ExportButtonProps {
	disabled?: boolean;
	isExporting?: boolean;
	onClick(): void;
}

export function ExportButton({ disabled, isExporting, onClick }: ExportButtonProps) {
	return (
		<button
			type='button'
			className='flex items-center gap-1.5 h-8 px-3 rounded border border-cPurple-600 bg-cPurple-600 text-sm font-semibold text-white tracking-wide transition-colors hover:bg-cPurple-700 hover:border-cPurple-700 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-cPurple-600 disabled:hover:border-cPurple-600'
			disabled={disabled || isExporting}
			onClick={onClick}
		>
			Exportovat do XLSX
			{isExporting ? (
				<SpinningLoadingIcon className='w-3 h-3 flex-shrink-0' />
			) : (
				<FaFileExport className='w-3 h-3 flex-shrink-0' />
			)}
		</button>
	);
}
